(function() {
    var isProductPage = window.location.pathname.indexOf('/products/') !== -1;
    if (!isProductPage) return;
    if (window.location.hash !== '#judgeme_product_reviews') return;

    var attempts = 0;
    var interval = setInterval(function() {
        attempts++;
        var widget = document.querySelector('#judgeme_product_reviews.jdgm--done-setup-widget');
        var trigger = widget ? widget.querySelector('[data-testid="write-review-button"], .jdgm-write-rev-link') : null;
        if (trigger) {
        clearInterval(interval);
        trigger.click();
        history.replaceState(null, '', window.location.pathname + window.location.search);
        }
        if (attempts >= 30) clearInterval(interval);
    }, 100);
})();

document.addEventListener('frcp.orders.orderMounted', function(event) {
  var order = event.detail.order;
  var orderElement = event.detail.el;
  var lineItems = orderElement.querySelectorAll('.frcp-order__line-item');
  for (var i = 0; i < lineItems.length; i++) {
    var lineItem = lineItems[i];
    var lineItemInfo = lineItem.querySelector('.frcp-order__line-item-info');
    var lineItemReview = document.createElement('a');
    lineItemReview.href = lineItem.href + '/#judgeme_product_reviews';
    lineItemReview.setAttribute('target', '_blank');
    lineItemReview.setAttribute('rel', 'noopener noreferrer');
    lineItemReview.className = 'frcp-order__line-item-review-tag';
    lineItemReview.innerHTML = '<span class="frcp-order__line-judgeme-review_tag">Yorum yap</span>';
    lineItemInfo.appendChild(lineItemReview);
  }
});